export default "/_next/static/images/c3a70cfd1dd266b6f436a4750df3f0ce.png";